import { OneActData } from '../../../types';
import styles from './Widget.module.css';

interface OneActProps {
  data: OneActData;
}

const OneAct = ({ data }: OneActProps) => {
  if (!data) {
    return null;
  }

  const { avatar, name, description } = data;

  return (
    <div className={styles.OneAct}>
      <div className={styles.personInfo}>
        <img
          src={avatar}
          alt={name}
          className={styles.avatar}
          onError={(e) => { 
            const target = e.target as HTMLImageElement;
            target.onerror = null; 
            target.src = 'https://placehold.co/48x48/E0E7FF/4F46E5?text=MH'; 
          }}
        />
        <div>
          <h4 className={styles.name}>{name}</h4>
          <p className={styles.description}>
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OneAct;
